// extracted by mini-css-extract-plugin
module.exports = {"imagesWrapper":"TP"};